import { useMemo } from "react";
import { useUser } from "src/shared/context/UserContext";
import { PrintData } from "src/print-configuration/PrintConfigration";
import { splitDateTime } from "src/shared/components/dateTime";
import { Order } from "src/shared/services/interfacev2";
import { useUserHelpers } from "src/shared/utils/userHelpers";

const useResPrintData = (order: Order | null) => {
  const { user } = useUser();
  const { getUserNameById } = useUserHelpers();
    const creatorName = getUserNameById(order?.orders?.[0]?.createdBy);

  const printData = useMemo<PrintData | null>(() => {
    if (!order || !user) return null;

    const txn = order.orders?.[0];
    const lastOrder = order.orders?.[order.orders.length - 1];
    // ✅ Get tip from the last order
    const tipAmount = Number(lastOrder?.tip || 0);
    /** ✅ Amount calculations */
    const finalAmount = Number(txn?.finalAmount || 0);
    /** ✅ paid calculations */
    const paidAmount = order.paymentHistory?.reduce( (sum, p) => sum + Number(p.receivedAmount || 0),0 ) || 0;
    /** ✅ unpaid calculations */
    const lastTxn = order.orders && order.orders.length > 0 ? order.orders[order.orders.length - 1] : null;
    const { date: orderDate, time: orderTime } = splitDateTime(txn?.orderedOn?.$date ?? "");

    /** ✅ Products (flatten from orderDetails) */
    const products =
      order.orderDetails?.flatMap((detail) =>
        detail.products.map((product) => ({
          productName: product.name || "",
          arabicword: product.arabicName || "",
          amount: Number(product.unitPrice || 0),
          quantity: Number(product.quantity || 0),
          totalPrice: Number(product.unitPrice * product.quantity || 0),
          Type: product.type || "",
        })),
      ) || [];

    return {
      CustomerName: [order.customerDetails.firstName, order.customerDetails.middleName, order.customerDetails.lastName].filter(Boolean).join(" ") || "",
      CustomerPhon: order.customerDetails.phones?.[0]?.phone?.toString() || "",
      OrderId: txn?.orderId || "",
      OrderStatus: txn?.status || "",
      Date: orderDate,
      Time: orderTime,
      Products: products,
      Paid: paidAmount,
      unpaid: Number(lastTxn?.remainingAmount || 0),
      total: Number(txn.orderAmount || 0),
      subtotal: finalAmount,
      discount: Number(txn?.discount || 0),
      paymentMethod: order.paymentHistory?.map((p) => p.paymentMethod).join(", ") || "",
      busnessName: user.orgName || "",
      busnessArabicName: user.orgArabicName || "",
      businessLocation: user.businessLocation || "",
      phoneNum: user.phones || "",
      billNo: txn?.billNumber || 0,
      parcelFee: txn?.parcelFee || 0,
      tip: tipAmount,
      Tip: tipAmount,
      deliveryFee: txn.deliveryFee,
      OSB: paidAmount ? 0 : txn.remainingAmount,
      createdBy: creatorName || "N/A",
    };
  }, [order, user]);

  return printData;
};

export default useResPrintData;
